import { useState } from "react";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { TagAssignmentService } from "@/services/tagAssignment/tagAssignment.service";

export const useTagAssignmentRuns = (limit: number = 10) => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const [offset, setOffset] = useState(0);

  const { runs, total, error, isLoading, mutate } = TagAssignmentService.getTagAssignmentRuns(
    sessionCurrentWorkspaceId,
    offset,
    limit,
  );

  const totalPages = total ? Math.ceil(total / limit) : 0;
  const currentPage = Math.floor(offset / limit) + 1;

  const goToPage = (page: number) => {
    const newOffset = (page - 1) * limit;
    setOffset(newOffset);
  };

  return {
    runs,
    total,
    error,
    isLoading,
    mutate,
    offset,
    limit,
    totalPages,
    currentPage,
    goToPage,
  };
};
